import request from "@/utils/request";

export function fetchExample(param) {
    return request({
        url: 'api/console/instance/running/list',
        method: 'post',
		data: param
    })
}

export function userAdd(param) {
  return request({
    url: 'api/console/user/create',
    method: 'post',
    data: param
  })
}

export function fetchList(param) {
  return request({
    url: 'api/console/user/list',
    method: 'post',
    data: param
  })
}

export function setPwd(param) {
  return request({
    url: 'api/console/user/set/password',
    method: 'post',
    data: param
  })
}

export function userDelete(param) {
  return request({
    url: 'api/console/user/delete',
    method: 'post',
    data: param
  })
}

